import { useEffect, memo } from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { getTahunConfig_act } from '../../redux/ducks/settings/actions'

const YearInit = ({ tahunConfig, getTahunConfig_act }) => {
    const navigate = useNavigate()
    let year = new Date().getFullYear().toString()
    useEffect(() => {
        getTahunConfig_act().then((response) => {
            if(response.status === "success"){
                console.log("berhasil ", response.data.result.year);
                
                year = response.data.result.year
            }
            navigate(`/tahun/${year}`)
        })
    },[])
    return (
        <></>
    )
}


const mapStateToProps = (state) => ({
    tahunConfig: state.settingsState.tahunConfig,
});

const mapDispatchToProps = {
    getTahunConfig_act,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(YearInit)